import './CheckBox.scss';
import { FC } from 'react';

interface CheckBoxProps {
  isActive?: boolean;
  hasValue?: boolean;
}

const CheckBox: FC<CheckBoxProps> = ({ isActive = false, hasValue = false }) => {
  return (
    <div className={`check-box-container ${!hasValue ? 'check-box-container--has-value' : ''}`}>
      <div className={`checkbox ${isActive ? 'checkbox--active' : ''}`}>
        {isActive && (
          <svg
            xmlns='http://www.w3.org/2000/svg'
            width='10'
            height='10'
            viewBox='0 0 10 10'
            fill='none'
          >
            <path
              d='M8.33341 2.5L3.75008 7.08333L1.66675 5'
              stroke='white'
              strokeWidth='1.66667'
              strokeLinecap='round'
              strokeLinejoin='round'
            />
          </svg>
        )}
      </div>
    </div>
  );
};

export default CheckBox;
